import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-2/mainSection-multiple-inputs-v-2';

const ProductAdd = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
// MainTransferID	
// UserID	
// TransferDate	
// FromShopID	
// ToShopID
  
const [inputProps, setInputProps] = useState({
  ProductID: { name: 'ProductID', value: props.ProductID || '', enabled: false },
  CompanyID: { name: 'CompanyID', value: props.CompanyID || '' },
  ProductName: { name: 'ProductName', value: props.ProductName || '' },
ProductCategoryName: {
    name: { id: 'ProductCategoryID', value: 'ProductCategoryName' },
    caption: 'Select Product Category',
    value: { id: props.ProductCategoryID || 'undefined', value: props.ProductCategoryName || '' },
    dataSource: { type: 'Route', route: 'ProductCategory' },
    addNew: { Route: 'ProductCategory', Security: 'Product Category' },
},
OpeningQuantity: { name: 'OpeningQuantity',caption:'Opening Quantity', value: props.OpeningQuantity || 0 ,decimal:2 },
OpeningRate: { name: 'OpeningRate',caption:'Opening Rate', value: props.OpeningRate || 0 ,decimal:2 },
OpeningAmount: { name: 'OpeningAmount',caption:'Opening Amount', value: props.OpeningAmount || 0 ,decimal:2 },
ExpenseAccount: {
  name: { id: 'AccountIDExpense', value: 'AccountTitle' },
  caption: 'Select Expense Account',
  value: { id: props.AccountIDExpense || 'undefined', value: props.AccountTitle || '' },
  dataSource: { type: 'Route', route: 'AccountIDExpense' },
  addNew: { Route: 'AgentAccounts', Security: 'AgentAccounts' },

},
  
});
// EXTRA CODE START

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
  const handleInputChange = async (value, name) => {
    // Copy current state
    let updatedInputProps = { ...inputProps };

    // Update the changed field
    if (updatedInputProps[name]) {
      updatedInputProps[name] = {
        ...updatedInputProps[name],
        value: value
      };
    }

    // If OpeningQuantity or OpeningRate changed, recalculate OpeningAmount
    if (name === 'OpeningQuantity' || name === 'OpeningRate') {
      // Get the latest values
      const openingQuantity =
        name === 'OpeningQuantity' ? parseFloat(value) || 0 : parseFloat(updatedInputProps.OpeningQuantity.value) || 0;
      const openingRate =
        name === 'OpeningRate' ? parseFloat(value) || 0 : parseFloat(updatedInputProps.OpeningRate.value) || 0;
      const openingAmount = parseFloat((openingQuantity * openingRate).toFixed(2));

      // Update OpeningAmount in state
      updatedInputProps.OpeningAmount = {
        ...updatedInputProps.OpeningAmount,
        value: openingAmount
      };
    }

    setInputProps(updatedInputProps);
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [
    { Input: TextComponent, Props: { ...inputProps.ProductName, setInputProps }, ColumnSize: 6 },
    { Input: DropdownComponent, Props: { ...inputProps.ProductCategoryName, setInputProps }, ColumnSize: 6 },
    { Input: NumberComponent, Props: { ...inputProps.OpeningQuantity, setInputProps, onChange:handleInputChange }, ColumnSize: 6 },
    { Input: NumberComponent, Props: { ...inputProps.OpeningRate, setInputProps,onChange:handleInputChange }, ColumnSize: 6 },
    { Input: NumberComponent, Props: { ...inputProps.OpeningAmount, setInputProps }, ColumnSize: 6 },
    { Input: DropdownComponent, Props: { ...inputProps.ExpenseAccount, setInputProps }, ColumnSize: 6 },
    { Input: HiddenComponent, Props: { ...inputProps.CompanyID, setInputProps }, ColumnSize: 0 }
  ];  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Product ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default ProductAdd;
